// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- HERO SECTION --- */
.hero .container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.sandbox-container {
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.sandbox-container:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 32px rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.3);
}

/* Animation for Sandbox Result */
.animate-fade-up {
  animation: fadeUp 0.4s ease-out forwards;
}

.sandbox-card {
  background-color: var(--card-bg) !important;
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

/* Input Field */
.sandbox-input {
  background-color: var(--bg-color) !important;
  color: var(--text-color) !important;
}

.sandbox-input::placeholder {
  color: var(--muted-text);
  opacity: 0.7;
}

.sandbox-result-box {
  background-color: var(--bg-color) !important;
  border-color: var(--border-color) !important;
}

/* Card Shadow adjustment for Dark Mode */
[data-theme="dark"] .sandbox-card {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5) !important;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

#btn-analyze {
  transition: all 0.3s ease;
}

#btn-analyze:active {
  transform: scale(0.95);
}

.bg-purple-soft {
  background-color: #f5f3ff;
}

/* --- VERTICAL TIMELINE (GUIDE) SECTION--- */
.vertical-timeline {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  padding-left: 20px;
  padding-top: 20px;
}

.timeline-item {
  position: relative;
  padding-left: 60px;
  padding-bottom: 100px;
}

.timeline-item::before {
  content: "";
  position: absolute;
  left: 14px;
  top: 40px;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #e2e8f0, #f1f5f9);
}

.timeline-item:last-child::before {
  display: none;
}

.timeline-dot {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 800;
  font-size: 18px;
  z-index: 2;
}

.timeline-dot.bg-purple {
  background: var(--primary-purple);
  box-shadow: 0 4px 10px rgba(124, 58, 237, 0.3);
}
.timeline-dot.bg-blue {
  background: #3b82f6;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
}
.timeline-dot.bg-emerald {
  background: #10b981;
  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
}

.timeline-content {
  background: #ffffff;
  padding: 32px;
  border-radius: 28px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.timeline-item:hover .timeline-content {
  border-color: var(--primary-purple);
  transform: translateX(15px);
  box-shadow: 0 20px 40px rgba(124, 58, 237, 0.06);
}

/* --- VERTICAL FEATURE SHOWCASE --- */
.feature-graphic {
  background-color: var(--card-bg) !important;
  border: 1px solid var(--border-color);
  height: 350px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
  overflow: visible;
}

[data-theme="dark"] .shadow-blue {
  box-shadow: 0 20px 50px rgba(59, 130, 246, 0.15) !important;
}

[data-theme="dark"] .shadow-emerald {
  box-shadow: 0 20px 50px rgba(16, 185, 129, 0.15) !important;
}

[data-theme="dark"] .feature-graphic:hover {
  transform: translateY(-10px) scale(1.02);
  border-color: var(--primary-purple);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4) !important;
}

.feature-graphic:hover {
  transform: translateY(-15px) scale(1.02);
}

feature-graphic.shadow-indigo:hover {
  box-shadow: 0 40px 80px -15px rgba(124, 58, 237, 0.15);
}
.feature-graphic.shadow-emerald:hover {
  box-shadow: 0 40px 80px -15px rgba(16, 185, 129, 0.15);
}
.feature-graphic.shadow-blue:hover {
  box-shadow: 0 40px 80px -15px rgba(59, 130, 246, 0.15);
}

.floating-badge {
  position: absolute;
  bottom: 30px;
  right: 30px;
  background: var(--primary-purple);
  color: white;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.8rem;
  transition: all 0.3s ease;
  z-index: 2;
}

[data-theme="dark"] .floating-badge.success {
  background: #059669; /* Dark Emerald */
}

[data-theme="dark"] .floating-badge.info {
  background: #0284c7; /* Dark Blue */
}

[data-theme="dark"] .feature-graphic i {
  filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.05));
}

.feature-graphic:hover .floating-badge {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.lead-sm {
  font-size: 1.1rem;
  line-height: 1.7;
}

.mini-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

/* Purple Icon */
.icon-box-purple {
  background-color: #f5f3ff; /* Light mode */
  color: var(--primary-purple);
}
[data-theme="dark"] .icon-box-purple {
  background-color: rgba(139, 92, 246, 0.15); /* Soft purple transparent */
  color: #a78bfa;
}

/* Blue Icon */
.icon-box-blue {
  background-color: #eff6ff;
  color: #3b82f6;
}
[data-theme="dark"] .icon-box-blue {
  background-color: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
}

/* Emerald Icon */
.icon-box-emerald {
  background-color: #ecfdf5;
  color: #10b981;
}
[data-theme="dark"] .icon-box-emerald {
  background-color: rgba(16, 185, 129, 0.15);
  color: #34d399;
}

/* --- FAQ SECTION --- */
.faq-item {
  border-color: #f1f5f9 !important;
  transition: all 0.3s ease;
}

.faq-divider {
  height: 1px;
  background-color: var(--border-color);
  width: 100%;
  opacity: 0.6;
}

.faq-header {
  transition: all 0.3s ease;
}

.faq-header:hover h6 {
  color: var(--primary-purple) !important;
}

.faq-icon-wrapper {
  width: 35px;
  height: 35px;
  border-radius: 10px;
  background-color: #f5f3ff; /* Light mode  */
  color: var(--primary-purple);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.faq-header:not(.collapsed) .faq-icon-wrapper {
  background-color: var(--primary-purple);
  color: #fff;
  transform: rotate(135deg);
}

.faq-header:not(.collapsed) h6 {
  color: var(--primary-purple) !important;
}

.faq-header:hover h6 {
  color: var(--primary-purple);
}

[data-theme="dark"] .faq-icon-wrapper {
  background-color: rgba(139, 92, 246, 0.1); /* Soft purple transparent */
  color: #a78bfa;
}

[data-theme="dark"] .faq-header:not(.collapsed) .faq-icon-wrapper {
  background-color: var(--primary-purple);
  color: #fff;
  box-shadow: 0 0 15px rgba(139, 92, 246, 0.3);
}

[data-theme="dark"] .faq-header h6 {
  color: #f1f5f9;
}

/* Custom Collapse Animation */
.faq-accordion .collapse {
  transition: all 0.3s ease;
}

.cta-banner {
  background: linear-gradient(135deg, var(--primary-purple) 0%, #6d28d9 100%);
  position: relative;
  overflow: hidden;
}

.cta-banner::before {
  content: "";
  position: absolute;
  top: -50px;
  right: -50px;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.shadow-indigo-lg {
  box-shadow: 0 30px 60px -10px rgba(109, 40, 217, 0.3);
}

.cta-banner .btn-light:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* --- RESPONSIVE GUIDE & TIMELINE --- */
@media (max-width: 992px) {
  .vertical-timeline {
    max-width: 95%;
  }

  .mini-icon {
    width: 50px;
    height: 50px;
    font-size: 1.4rem;
  }

  .timeline-content {
    padding: 28px;
  }
}

@media (max-width: 768px) {
  .timeline-item {
    padding-left: 45px;
    padding-bottom: 70px;
  }

  .timeline-dot {
    width: 35px;
    height: 35px;
    font-size: 16px;
    left: -2px;
  }

  .timeline-item::before {
    left: 15px;
  }

  .mini-icon {
    width: 48px;
    height: 48px;
    font-size: 1.3rem;
    margin-right: 12px !important;
  }

  .timeline-content {
    padding: 20px;
    border-radius: 20px;
  }

  .timeline-content h5 {
    font-size: 1.1rem;
  }

  .timeline-content p {
    font-size: 0.9rem;
  }
  .faq-header h6 {
    font-size: 14px;
    padding-right: 20px;
  }
}

@media (max-width: 480px) {
  .timeline-item {
    padding-left: 40px;
  }

  .timeline-dot {
    width: 30px;
    height: 30px;
    font-size: 14px;
    left: 0;
  }

  .timeline-item::before {
    left: 14px;
  }

  .timeline-content .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .mini-icon {
    margin-bottom: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA,iCAAiC;AACjC;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA,yCAAyC;AACzC;EACE,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,sCAAsC;AACtC;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uDAAuD;EACvD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB,EAAE,iBAAiB;AACxC;;AAEA;EACE,mBAAmB,EAAE,cAAc;AACrC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,yBAAyB,EAAE,eAAe;EAC1C,4BAA4B;AAC9B;AACA;EACE,0CAA0C,EAAE,4BAA4B;EACxE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB,EAAE,gBAAgB;EAC3C,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC,EAAE,4BAA4B;EACvE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA;EACE,2EAA2E;EAC3E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,wCAAwC;AACxC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,OAAO;EACT;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* --- HERO SECTION --- */\n.hero .container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.sandbox-container {\n  transition: all 0.3s ease;\n  border: 1px solid transparent;\n}\n\n.sandbox-container:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 16px 32px rgba(59, 130, 246, 0.15);\n  border-color: rgba(59, 130, 246, 0.3);\n}\n\n/* Animation for Sandbox Result */\n.animate-fade-up {\n  animation: fadeUp 0.4s ease-out forwards;\n}\n\n.sandbox-card {\n  background-color: var(--card-bg) !important;\n  border: 1px solid var(--border-color);\n  transition: all 0.3s ease;\n}\n\n/* Input Field */\n.sandbox-input {\n  background-color: var(--bg-color) !important;\n  color: var(--text-color) !important;\n}\n\n.sandbox-input::placeholder {\n  color: var(--muted-text);\n  opacity: 0.7;\n}\n\n.sandbox-result-box {\n  background-color: var(--bg-color) !important;\n  border-color: var(--border-color) !important;\n}\n\n/* Card Shadow adjustment for Dark Mode */\n[data-theme=\"dark\"] .sandbox-card {\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5) !important;\n}\n\n@keyframes fadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n#btn-analyze {\n  transition: all 0.3s ease;\n}\n\n#btn-analyze:active {\n  transform: scale(0.95);\n}\n\n.bg-purple-soft {\n  background-color: #f5f3ff;\n}\n\n/* --- VERTICAL TIMELINE (GUIDE) SECTION--- */\n.vertical-timeline {\n  max-width: 800px;\n  margin: 0 auto;\n  position: relative;\n  padding-left: 20px;\n  padding-top: 20px;\n}\n\n.timeline-item {\n  position: relative;\n  padding-left: 60px;\n  padding-bottom: 100px;\n}\n\n.timeline-item::before {\n  content: \"\";\n  position: absolute;\n  left: 14px;\n  top: 40px;\n  bottom: 0;\n  width: 2px;\n  background: linear-gradient(to bottom, #e2e8f0, #f1f5f9);\n}\n\n.timeline-item:last-child::before {\n  display: none;\n}\n\n.timeline-dot {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 800;\n  font-size: 18px;\n  z-index: 2;\n}\n\n.timeline-dot.bg-purple {\n  background: var(--primary-purple);\n  box-shadow: 0 4px 10px rgba(124, 58, 237, 0.3);\n}\n.timeline-dot.bg-blue {\n  background: #3b82f6;\n  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);\n}\n.timeline-dot.bg-emerald {\n  background: #10b981;\n  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);\n}\n\n.timeline-content {\n  background: #ffffff;\n  padding: 32px;\n  border-radius: 28px;\n  border: 1px solid #f1f5f9;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);\n  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.timeline-item:hover .timeline-content {\n  border-color: var(--primary-purple);\n  transform: translateX(15px);\n  box-shadow: 0 20px 40px rgba(124, 58, 237, 0.06);\n}\n\n/* --- VERTICAL FEATURE SHOWCASE --- */\n.feature-graphic {\n  background-color: var(--card-bg) !important;\n  border: 1px solid var(--border-color);\n  height: 350px;\n  border-radius: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);\n  cursor: pointer;\n  overflow: visible;\n}\n\n[data-theme=\"dark\"] .shadow-blue {\n  box-shadow: 0 20px 50px rgba(59, 130, 246, 0.15) !important;\n}\n\n[data-theme=\"dark\"] .shadow-emerald {\n  box-shadow: 0 20px 50px rgba(16, 185, 129, 0.15) !important;\n}\n\n[data-theme=\"dark\"] .feature-graphic:hover {\n  transform: translateY(-10px) scale(1.02);\n  border-color: var(--primary-purple);\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4) !important;\n}\n\n.feature-graphic:hover {\n  transform: translateY(-15px) scale(1.02);\n}\n\nfeature-graphic.shadow-indigo:hover {\n  box-shadow: 0 40px 80px -15px rgba(124, 58, 237, 0.15);\n}\n.feature-graphic.shadow-emerald:hover {\n  box-shadow: 0 40px 80px -15px rgba(16, 185, 129, 0.15);\n}\n.feature-graphic.shadow-blue:hover {\n  box-shadow: 0 40px 80px -15px rgba(59, 130, 246, 0.15);\n}\n\n.floating-badge {\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n  background: var(--primary-purple);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 100px;\n  font-weight: 700;\n  font-size: 0.8rem;\n  transition: all 0.3s ease;\n  z-index: 2;\n}\n\n[data-theme=\"dark\"] .floating-badge.success {\n  background: #059669; /* Dark Emerald */\n}\n\n[data-theme=\"dark\"] .floating-badge.info {\n  background: #0284c7; /* Dark Blue */\n}\n\n[data-theme=\"dark\"] .feature-graphic i {\n  filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.05));\n}\n\n.feature-graphic:hover .floating-badge {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);\n}\n\n.lead-sm {\n  font-size: 1.1rem;\n  line-height: 1.7;\n}\n\n.mini-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n/* Purple Icon */\n.icon-box-purple {\n  background-color: #f5f3ff; /* Light mode */\n  color: var(--primary-purple);\n}\n[data-theme=\"dark\"] .icon-box-purple {\n  background-color: rgba(139, 92, 246, 0.15); /* Soft purple transparent */\n  color: #a78bfa;\n}\n\n/* Blue Icon */\n.icon-box-blue {\n  background-color: #eff6ff;\n  color: #3b82f6;\n}\n[data-theme=\"dark\"] .icon-box-blue {\n  background-color: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n}\n\n/* Emerald Icon */\n.icon-box-emerald {\n  background-color: #ecfdf5;\n  color: #10b981;\n}\n[data-theme=\"dark\"] .icon-box-emerald {\n  background-color: rgba(16, 185, 129, 0.15);\n  color: #34d399;\n}\n\n/* --- FAQ SECTION --- */\n.faq-item {\n  border-color: #f1f5f9 !important;\n  transition: all 0.3s ease;\n}\n\n.faq-divider {\n  height: 1px;\n  background-color: var(--border-color);\n  width: 100%;\n  opacity: 0.6;\n}\n\n.faq-header {\n  transition: all 0.3s ease;\n}\n\n.faq-header:hover h6 {\n  color: var(--primary-purple) !important;\n}\n\n.faq-icon-wrapper {\n  width: 35px;\n  height: 35px;\n  border-radius: 10px;\n  background-color: #f5f3ff; /* Light mode  */\n  color: var(--primary-purple);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.faq-header:not(.collapsed) .faq-icon-wrapper {\n  background-color: var(--primary-purple);\n  color: #fff;\n  transform: rotate(135deg);\n}\n\n.faq-header:not(.collapsed) h6 {\n  color: var(--primary-purple) !important;\n}\n\n.faq-header:hover h6 {\n  color: var(--primary-purple);\n}\n\n[data-theme=\"dark\"] .faq-icon-wrapper {\n  background-color: rgba(139, 92, 246, 0.1); /* Soft purple transparent */\n  color: #a78bfa;\n}\n\n[data-theme=\"dark\"] .faq-header:not(.collapsed) .faq-icon-wrapper {\n  background-color: var(--primary-purple);\n  color: #fff;\n  box-shadow: 0 0 15px rgba(139, 92, 246, 0.3);\n}\n\n[data-theme=\"dark\"] .faq-header h6 {\n  color: #f1f5f9;\n}\n\n/* Custom Collapse Animation */\n.faq-accordion .collapse {\n  transition: all 0.3s ease;\n}\n\n.cta-banner {\n  background: linear-gradient(135deg, var(--primary-purple) 0%, #6d28d9 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.cta-banner::before {\n  content: \"\";\n  position: absolute;\n  top: -50px;\n  right: -50px;\n  width: 200px;\n  height: 200px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n}\n\n.shadow-indigo-lg {\n  box-shadow: 0 30px 60px -10px rgba(109, 40, 217, 0.3);\n}\n\n.cta-banner .btn-light:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* --- RESPONSIVE GUIDE & TIMELINE --- */\n@media (max-width: 992px) {\n  .vertical-timeline {\n    max-width: 95%;\n  }\n\n  .mini-icon {\n    width: 50px;\n    height: 50px;\n    font-size: 1.4rem;\n  }\n\n  .timeline-content {\n    padding: 28px;\n  }\n}\n\n@media (max-width: 768px) {\n  .timeline-item {\n    padding-left: 45px;\n    padding-bottom: 70px;\n  }\n\n  .timeline-dot {\n    width: 35px;\n    height: 35px;\n    font-size: 16px;\n    left: -2px;\n  }\n\n  .timeline-item::before {\n    left: 15px;\n  }\n\n  .mini-icon {\n    width: 48px;\n    height: 48px;\n    font-size: 1.3rem;\n    margin-right: 12px !important;\n  }\n\n  .timeline-content {\n    padding: 20px;\n    border-radius: 20px;\n  }\n\n  .timeline-content h5 {\n    font-size: 1.1rem;\n  }\n\n  .timeline-content p {\n    font-size: 0.9rem;\n  }\n  .faq-header h6 {\n    font-size: 14px;\n    padding-right: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .timeline-item {\n    padding-left: 40px;\n  }\n\n  .timeline-dot {\n    width: 30px;\n    height: 30px;\n    font-size: 14px;\n    left: 0;\n  }\n\n  .timeline-item::before {\n    left: 14px;\n  }\n\n  .timeline-content .d-flex {\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n\n  .mini-icon {\n    margin-bottom: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
